/**
 * Document line validation schema
 * Validates document line fields (label and description) with character limits
 */

import * as Yup from 'yup'

/**
 * Single document line validation schema
 * - Label: Required, max 255 characters
 * - Description: Optional, max 2000 characters
 * - Price: Required integer
 * - Quantity: Required integer
 */
export const documentLineValidationSchema = Yup.object().shape({
  label: Yup.string()
    .required('Titel is verplicht')
    .max(255, 'Het label mag niet meer dan 255 tekens bevatten.'),

  description: Yup.string()
    .nullable()
    .max(2000, 'De beschrijving mag niet meer dan 2.000 tekens bevatten.'),

  price: Yup.number()
    .required('Prijs is verplicht')
    .integer('Prijs moet een geheel getal zijn'),

  quantity: Yup.number()
    .required('Aantal is verplicht')
    .integer('Aantal moet een geheel getal zijn')
    .min(1, 'Aantal moet minimaal 1 zijn'),

  vat_code_id: Yup.number().nullable(),
})

export const documentValidationSchema = Yup.object().shape({
  lines: Yup.array()
    .of(documentLineValidationSchema)
    .min(1, 'Minimaal één regel is verplicht'),
})
